module.exports = __webpack_public_path__ + "static/ibikelogo-217303a58fa6815b421e63bb0dd450ea.jpg";